import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTourContext } from '../contexts/TourContext';
import { TourOverlay } from './TourOverlay';
import { TourTooltip } from './TourTooltip';

export function TourRenderer() {
  const { activeTour, activeStep, isActive, state, nextStep, prevStep, skipTour } =
    useTourContext();
  const { pathname } = useLocation();

  // Auto-dismiss tour if the user navigates away from the tour's target page
  useEffect(() => {
    if (!isActive || !activeTour?.pathname) return;
    if (!pathname.startsWith(activeTour.pathname)) {
      skipTour();
    }
  }, [isActive, activeTour, pathname, skipTour]);

  if (!isActive || !activeTour || !activeStep) return null;

  // Double-check: don't render if on wrong page
  if (activeTour.pathname && !pathname.startsWith(activeTour.pathname)) return null;

  return (
    <>
      <TourOverlay
        targetSelector={activeStep.targetSelector}
        onClickOutside={skipTour}
      />
      <TourTooltip
        step={activeStep}
        tour={activeTour}
        stepIndex={state.currentStepIndex}
        totalSteps={activeTour.steps.length}
        onNext={nextStep}
        onPrev={prevStep}
        onSkip={skipTour}
      />
    </>
  );
}
